<!-- <div class="row justify-content-center mt-3 d-flex flex-lg-row-reverse m-md-css">
    <div class="col-lg-6 col-12">
    </div>
    <div class="col-lg-5 col-12" *ngIf="!hideEMI">
        <app-assist-emi-table [Downpayment]="Downpayment" [EmiAmount]="EmiAmount" [Loanamount]="Loanamount"
        [NumberOfTotalEMI]="NumberOfTotalEMI" [ProcessingFee]="ProcessingFee" [PayToday]="PayToday"
        [FirstEMIDueDate]="FirstEMIDueDate">
    </app-assist-emi-table>
</div>
</div> -->
<app-assist-personal-details [FirstName]="FirstName" [Mobile]="Mobile" [Email]="Email" [PAN]="PAN" [DOB]="DOB"
    [Address]="Address" [DocsRequired]="DocsRequired" [btnProceedText]="btnProceed" [origin]="origin"
    [destination]="destination" [creditScore]="creditScore" [traveldate]="travelDate" [hideEMI]="hideEMI"
    [emiTableData]="emiTableData"></app-assist-personal-details>

<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>

<!-- <button class="btn btn-primary" (click)="notifyHost()">test</button> -->